module.exports = "<activity-types-legend [activityTypes]=\"activityTypes\">\r\n</activity-types-legend>"


//////////////////
// WEBPACK FOOTER
// ./client/app/activities/daily-activities/activity-types-display.component.html
// module id = 1271
// module chunks = 1